import { useTranslation } from 'react-i18next';
import { classNames } from '../helpers/classes';
import localizedRoute from '../utils/localizedRoute';
import Link from 'next/link';

const ContactMenu = ({ actual_page }: { actual_page: string }) => {
  const { t } = useTranslation();
  return (
    <div className="flex mb-5">
      <Link
        href={localizedRoute('/contacts')}
        className={classNames(
          'mr-5 text-3xl font-sans',
          actual_page === 'contacts' ? '' : 'text-grey'
        )}
      >
        {t('CONTACT_US_PRIVATE')}
      </Link>
      <Link
        href={localizedRoute('/b2bcontacts')}
        className={classNames(
          'mr-5 text-3xl font-sans',
          actual_page === 'b2bcontacts' ? '' : 'text-grey'
        )}
      >
        {t('CONTACT_US_B2B')}
      </Link>
      <Link
        href={localizedRoute('/press-contacts')}
        className={classNames(
          'mr-5 text-3xl font-sans',
          actual_page === 'press-contacts' ? '' : 'text-grey'
        )}
      >
        {t('CONTACT_US_PRESS')}
      </Link>
    </div>
  );
};

export default ContactMenu;
